import Modal from "react-modal";
import { Container, Contents, Title } from "./styled";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { useEffect, useState } from 'react'
import { saveAs } from "file-saver";
import { toast } from "react-toastify";


const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        width: "540px",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "transparent",
        padding: "0px",
        margin: "0px",
        borderRadius: "8px",
        border: "none"
    },
    overlay: {
        backgroundColor: "rgba(10,23,55,0.5)",
        zIndex: "99999999"
    },
};



const ModalCadCodes = (props) => {

    const dispatch = useDispatch()
    const language = useSelector((state) => state.reducerLanguage);
    const { id } = useParams();
    const reducerAddCodes = useSelector((state) => state.reducerAddCodes);

    const [code, setCode] = useState("")



    const closeModal = () => {
        //props.handleClick()

        setTimeout(() => {
            props.setVisible(false)
            props.goSearch()
            //props.setDataModalDeleteCompleted([])
        }, 0);
    }

    useEffect(() => {

    }, [])

    const save = () => {
        dispatch({ type: "SAGA_ADD_CODES", payload: { code: code, id: id } })
        //closeModal()
    }


    useEffect(() => {
        if (reducerAddCodes.loading == false && reducerAddCodes.error == false && reducerAddCodes.data.length == 0) {
        } else {
            console.log("reducerAddCodes", reducerAddCodes)
            const id = "reducerAddCodes"
            if (reducerAddCodes.loading) {
                toast.loading("Aguarde..", { toastId: id })
            } else {
                if (reducerAddCodes.error) toast.update(id, { render: "Erro ao cadastrar código", type: "error", isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
                else {
                    toast.update(id, { render: "Código cadastrado com sucesso", type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
                    //props.goSearch()
                    //closeModal()
                    props.setVisible(false)
                    props.goSearch()
                    dispatch({ type: "CODES_ADD_RESET" })
                }
            }
        }
    }, [reducerAddCodes])

    return (
        <Modal
            isOpen={props.visible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() => { }}
        >
            <Container>
                <Title>
                    <div>
                        <label>Cadastro de códigos</label>
                        <XMarkIcon onClick={() => { closeModal() }} style={{ cursor: "pointer" }} width={20} />
                    </div>
                    <label >
                        {"Para cadastrar varios códigos de uma vez, use virgulas. (Exemplo: cod01,cod02,cod03)."}
                    </label>
                </Title>
                <Contents>
                    <div>
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            Código
                        </label>
                        <div className="mt-2">
                            <input
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                id="code"
                                name="code"
                                type="text"
                                placeholder="COD-01,COD02"
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#111827] sm:text-sm/6"
                            />
                        </div>
                    </div>
                    <div className="flex shrink-0 justify-end px-4 py-4">
                        <button
                            type="button"
                            onClick={() => { closeModal() }}
                            className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={() => code.trim().length > 0 && save()}
                            type="submit"
                            className="ml-4 inline-flex justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-500"
                        >
                            Salvar
                        </button>
                    </div>
                </Contents>
            </Container>

        </Modal >
    )
}

export default ModalCadCodes

